import { useTranslation } from 'react-i18next';

const FamilyBuildingGoals = ({ nextStep, prevStep, handleChange, handleFamilyGoalChange, formData, error,step, totalSteps, isHighmarkPortal }) => {
  const { t } = useTranslation();

  // Store only translated values
  const goalList = [
    "Pregnancy & Fertility Treatment",
    "Fertility Preservation",
    "Adoption",
    "Surrogacy",
    "Donor-Assisted Family Building",
    "Fostering/Foster-to-Adopt",
    "Exploring Options"
  ];

  const handleRadioChange = (e) => {
    const { value } = e.target;

    if (handleFamilyGoalChange) {
      handleFamilyGoalChange(value);
      return;
    }

    handleChange({ target: { name: 'familyGoals', value: [value] } });
  };

  return (
    <div>
      <h3 className="page-heading-secondary-black-500 mb-5">{t('buildinggoals')}</h3>
      <p>Choose one option</p>
      {goalList.map((label, index) => (
        <div key={index} className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            name="familyGoals"
            className="form-check-input radio-btn win-form-check-input"
            value={label}
            checked={formData.familyGoals[0] === label}
            onChange={handleRadioChange}
          />
          <label className="multistep-form-radio-checkbox-label">{label}</label>
        </div>
      ))}

      {error && <p className="text-danger">{error}</p>}

      <div className="mt-5">
      {isHighmarkPortal ? (
          <div className="pagination-wrapper mt-5">
            <button className="previous-btn" onClick={prevStep}></button>
            <span className="me-3">{step} of {totalSteps}</span>
            <button className="next-btn" onClick={nextStep}></button>
          </div>
        ) : (
          <div className="mt-5">
            <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={prevStep}>{t('back')}</button>
            <button className="win-btn-primary mobile-view mb-3" onClick={nextStep}>{t('next')}</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FamilyBuildingGoals;
